export const langKeyMapper = {
  en: "engName",
  uk: "ukrName",
};
